import { render, staticRenderFns } from "./ResidentialTemplates.vue?vue&type=template&id=42a81523"
import script from "./ResidentialTemplates.vue?vue&type=script&lang=js"
export * from "./ResidentialTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports